import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import gb from "./languages/gb.json";
import rs from "./languages/rs.json";
import de from "./languages/de.json";

export const resources = {
  rs: {
    translation: rs,
  },

  gb: {
    translation: gb,
  },

  de: {
    translation: de,
  },
};

i18n.use(initReactI18next).init({
  compatibilityJSON: "v3",
  resources,
  defaultNS: "translation",
  fallbackLng: "gb",
});

export default i18n;
